import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
import Icon from "@mui/material/Icon";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const fieldLabelSx = {
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
  alignItems: "flex-start",
};

function AccountField({ label, value }) {
  return (
    <MDBox sx={fieldLabelSx}>
      <MDTypography variant="caption" fontWeight="medium" color="secondary">
        {label}
      </MDTypography>
      <MDTypography variant="body2" color="text" sx={{ wordBreak: "break-word" }}>
        {value}
      </MDTypography>
    </MDBox>
  );
}

AccountField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const yesNo = (value) => (value === "yes" ? "Yes" : "No");

function ContactLinkedAccountsMobileCards({
  accounts,
  loading,
  onViewCustomer,
  onEditAccount,
  onDeleteAccount,
  emptyMessage,
}) {
  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" py={3}>
        <CircularProgress size={28} />
      </MDBox>
    );
  }

  if (!accounts?.length) {
    return (
      <MDBox display="flex" justifyContent="center" py={3}>
        <MDTypography variant="body2" color="text">
          {emptyMessage}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox display="flex" flexDirection="column" gap={2}>
      {accounts.map((account) => (
        <Card
          key={account.customer_contact_link_id}
          variant="outlined"
          sx={{ overflow: "hidden" }}
        >
          <MDBox p={2}>
            <MDBox display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
              <MDTypography variant="button" fontWeight="medium" sx={{ wordBreak: "break-word", flex: 1 }}>
                {account.account}
              </MDTypography>
              <MDBox display="flex" gap={0.25} flexShrink={0}>
                <MDButton
                  variant="text"
                  color="info"
                  onClick={() => onViewCustomer(account.customer_id)}
                  sx={{ minWidth: "auto", p: "6px" }}
                >
                  <VisibilityIcon />
                </MDButton>
                <MDButton
                  variant="text"
                  color="info"
                  onClick={() => onEditAccount(account)}
                  sx={{ minWidth: "auto", p: "6px" }}
                >
                  <Icon>edit</Icon>
                </MDButton>
                <MDButton
                  variant="text"
                  color="error"
                  onClick={() => onDeleteAccount(account)}
                  sx={{ minWidth: "auto", p: "6px" }}
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            </MDBox>

            <Divider sx={{ my: 1.5 }} />

            <MDBox display="flex" flexDirection="column" gap={1.25}>
              <AccountField label="Primary Contact" value={yesNo(account.primary_contact)} />
              <AccountField label="Email" value={yesNo(account.get_email)} />
              <AccountField label="WhatsApp" value={yesNo(account.get_whatsapp)} />
              <AccountField label="Billing" value={yesNo(account.get_billing)} />
              <AccountField label="Notifications" value={yesNo(account.get_notification)} />
            </MDBox>
          </MDBox>
        </Card>
      ))}
    </MDBox>
  );
}

ContactLinkedAccountsMobileCards.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  onViewCustomer: PropTypes.func.isRequired,
  onEditAccount: PropTypes.func.isRequired,
  onDeleteAccount: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
};

ContactLinkedAccountsMobileCards.defaultProps = {
  loading: false,
  emptyMessage: "No linked accounts found",
};

export default ContactLinkedAccountsMobileCards;
